import { defineStore } from 'pinia'
import type { Language } from '~/types/language'

export const useLanguageStore = defineStore('language', {
    state: () => ({
        languages: null as Language[] | null,
        loaded: false,
    }),

    actions: {
        async fetchLanguages() {
            if (this.loaded) return

            const { $api } = useNuxtApp();

            await $api.get("/languages")
                .then((response) => {
                    this.languages = response.data;
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.loaded = true;
                })
        },
        clear() {
            this.languages = null
            this.loaded = false
        }
    }
})